import React from 'react';
import Dropdown from 'react-bootstrap/Dropdown';
const BasicInfoStep = ({ formData, setFormData, errors, filteredTokens, onNext }) => {
  return (
    <>
      <div className="wrappermain">
           <div className="textformobile">
          <div className="parentmbl d-none">
            <div className="parent">
              <h6>Basic Info</h6>
              <button>1/4</button>
            </div>
          </div>
        </div>
        <div className="bottommainbox">
          <div className="foruppperimage">
            <div className="drop_Sideeee">
              <Dropdown>
                <Dropdown.Toggle variant="success" id="dropdown-basic">
                  <div className="roooot_poll">
                    <div>
                      <h2>Root Pool</h2>
                      <p>{formData.selectedToken ? formData.selectedToken.projectName : "Select Root Pool"}</p>
                    </div>
                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                      <path d="M3 4.5 L6 7.5 L9 4.5" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </div>
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <div className="menu_baar">
                    <div className="menu_input">
                      <svg  className="svgicons" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
  <path d="M9.57624 9.57559L11.6673 11.6667L9.57624 9.57559ZM10.8189 6.57574C10.8189 8.91876 8.91947 10.8182 6.57645 10.8182C4.23339 10.8182 2.33398 8.91876 2.33398 6.57574C2.33398 4.23273 4.23339 2.33334 6.57645 2.33334C8.91947 2.33334 10.8189 4.23273 10.8189 6.57574Z" stroke="#4B5AFF" stroke-width="1.33333" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

                      <input
                        placeholder="Search"
                        type="text"
                        id="fname"
                        name="fname"
                        value={formData.searchTerm}
                        onChange={(e) => setFormData(prev => ({ ...prev, searchTerm: e.target.value }))}
                      />
                    </div>
                    <div className="rewarddd_img">
                      {filteredTokens.map(token => (
                        <Dropdown.Item
                          className="pool_innr"
                          key={token.id}
                          as="div"
                          onClick={() => setFormData(prev => ({ ...prev, selectedToken: token }))}
                        >
                          <img src={token.projectLogo} className='imgglogooo'/>
                          <h6>{token?.projectName}</h6>
                        </Dropdown.Item>
                      ))}
                    </div>
                  </div>
                </Dropdown.Menu>
              </Dropdown>
              {errors.selectedToken && <p className="error-text">{errors.selectedToken}</p>}
            </div>
          </div>
          <div className="innerbox">
            <h2>Tagline</h2>
            <input
              placeholder="Enter Tagline"
              type="text"
              id="fname"
              name="fname"
              value={formData.tagline}
              onChange={(e) => setFormData(prev => ({ ...prev, tagline: e.target.value }))}
            />
          </div>
          {errors.tagline && <p className="error-text">{errors.tagline}</p>}
          <div className="innerbox forheight">
            <h2>Pool Description</h2>
            <input
              placeholder="Enter Pool Description"
              type="text"
              id="fname"
              name="fname"
              value={formData.poolDescription}
              onChange={(e) => setFormData(prev => ({ ...prev, poolDescription: e.target.value }))}
            />
          </div>
          {errors.poolDescription && <p className="error-text">{errors.poolDescription}</p>}
        </div>
      </div>
      <div className="bottom-btns">
        <button onClick={onNext} className="continuebtnmain">Continue</button>
      </div>
    </>
  );
};

export default BasicInfoStep;